'use es6';

import { forwardRef, useRef } from 'react';
import { DragSource } from 'react-dnd-compat';
import { DragTypes } from '../../../constants/dragAndDrop';
import { jsx as _jsx } from "react/jsx-runtime";
const SET_DRAGGING_CALLBACK_DELAY = 500;
const UNSET_DRAGGING_CALLBACK_DELAY = 100;
const source = {
  canDrag(props) {
    return !props.readOnly;
  },
  beginDrag(props, _monitor, component) {
    var _window;
    const FALLBACK_MENU_WIDTH = ((_window = window) === null || _window === void 0 || (_window = _window.document) === null || _window === void 0 || (_window = _window.querySelector(`#menu-node-${props.id}`)) === null || _window === void 0 || (_window = _window.getBoundingClientRect()) === null || _window === void 0 ? void 0 : _window.width) || 0;
    let dragSourceBoundingRect = {
      width: FALLBACK_MENU_WIDTH
    };
    if (component && component.getBoundingClientRect) {
      // React DnD v2/v3: Direct DOM element access via component parameter
      dragSourceBoundingRect = component.getBoundingClientRect();
    } else if (props.componentDOMRef && props.componentDOMRef.current) {
      // React DnD v4: Use the stable DOM reference provided by the component
      dragSourceBoundingRect = props.componentDOMRef.current.getBoundingClientRect();
    }
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => props.setIsDragging(true), {
        timeout: SET_DRAGGING_CALLBACK_DELAY
      });
    } else {
      props.setIsDragging(true);
    }
    return {
      id: props.id,
      parentId: props.parentId,
      menuId: props.menuId,
      label: props.label,
      width: dragSourceBoundingRect.width
    };
  },
  endDrag(props) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => props.setIsDragging(false), {
        timeout: UNSET_DRAGGING_CALLBACK_DELAY
      });
    } else {
      props.setIsDragging(false);
    }
  },
  isDragging(props, monitor) {
    return props.id === monitor.getItem().id;
  }
};
export default function menuDragSource() {
  return Component => {
    const DragSourceComponent = DragSource(DragTypes.ADVANCED_MENUS_MENU_NODE, source, monitor => ({
      isDragging: monitor.isDragging()
    }))(Component);
    const ForwardedDragSource = /*#__PURE__*/forwardRef((props, forwardedRef) => {
      const componentRef = useRef(null);
      // Ref callback for the underlying component to register its DOM element
      const getDOMElementRef = element => {
        componentRef.current = element;
      };
      return /*#__PURE__*/_jsx(DragSourceComponent, Object.assign({}, props, {
        ref: forwardedRef || componentRef,
        componentDOMRef: componentRef,
        getDOMElementRef: getDOMElementRef
      }));
    });
    ForwardedDragSource.displayName = `MenuDragSource(${Component.displayName || Component.name || 'Component'})`;
    return ForwardedDragSource;
  };
}